<template>
    <div class="page-height background-detail">
        <v-container class="staff-page-container page-content-offset page-height">
       <TasksPage :isAllTask="true" :activities="activities" @getActivities="getActivities"></TasksPage>
        </v-container>
    </div>
</template>

<script>
import TasksPage from './TasksPage.vue';
import axios from 'axios';
import currentUserMixin from '/src/mixin/currentUserMixin.js';
import {openRoadApiUrl, version, activityCategories, uploadPath, uploadTypeCar, statusPending, statusInProgress, statusCompleted} from "/src/constants/config";
import _ from "lodash";
import moment from "moment";
import { mapActions } from "vuex";

export default {
    props: [],
    mixins: [currentUserMixin],

    data() {
		return {
            activities: [],
            status: "Pending",

            loadMore: true,
            page: 1,
            pageSize: 2,
		}
    },

    components: {
        TasksPage,
    },
  
    mounted() {	
        this.getActivities(statusPending);       
    }, 

    methods: {

        ...mapActions(["signOut"]),
        getActivities(status){
            this.status = status;
            if(this.currentUser && this.currentUser.details && this.currentUser.details.autoStorageId){     
                axios.get(this.url, this.$data.apiHeaders)
                    .then(response => this.setActivites(response))
                    .catch(error => this.onError(error));
            }         
        },

        setActivites(response) {
            this.activities = response.data.result.items.map(function(item){
                let obj = {};

                obj['userId'] = item.userId;
                obj['userFullName'] = item.userName;
                obj['carId'] = item.carId;
                obj['carRegistrationNo'] = item.carRegistrationNo;
                obj['carParkingLotId'] = item.carParkingLotId ? item.carParkingLotId : "24";
                obj['carCoverPhoto'] = item.carCoverPhoto;
                obj['activityCategoryId'] = item.activityCategoryId;
                obj['activityCategoryName'] = item.activityCategoryName;
                obj['dateAction'] = item.dateAction;
                obj['status'] = item.status;
                obj['id'] = item.id;
                obj['carPathSrc'] = item.carCoverPhoto 
                                    ? uploadPath + "/" + uploadTypeCar + "/" + item.carCoverPhoto
                                    : "";
                            
                let icon =  _.find(activityCategories, function(o){ return item.activityCategoryId == o.activityCategoryId });
                obj['activityCategoryIcon'] = icon ? icon.src : require('/src/assets/img/Others.png');

                return obj;
            });
        },
        onError(error){
            let message = "Failed";
            let details = error && error.response && error.response.data.error 
                    ? ( error.response.data.error.validationErrors ? error.response.data.error.details : error.response.data.error.message )
                    : "";
            if(error.response.code == 401) this.logout();
            else {
              this.$notify("error", message, details, {
                duration: 6000,
                permanent: false
              });
            }
        },
        logout() {
          this.signOut().then(() => {
              this.$router.push("/staff/login");
          });
        },
    },

    computed: {
        url(){
            let url = "";
            if(this.currentUser && this.currentUser.details && this.currentUser.details.autoStorageId){
                url = openRoadApiUrl + "/api/services/" + version + "/activity/staff/bucket?AutoStorageId=" + this.currentUser.details.autoStorageId + "&Status=" + this.status;
                if(this.status != statusCompleted ){
                    url = url + "&DateActionTo=" + moment().format("YYYY-MM-DD");
                }
            }
            return url;
        }
    }, 

    watch: {
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>